
import { defineComponent, onBeforeMount, PropType, reactive } from 'vue'

import NewModal from '@/common/new-components/NewModal/index.vue'
import NewSelect from '@/ui-kit/NewSelect/index.vue'

import { AssemblyContainersPayload, Container } from '@/new-services/types/planning'

import planningAPI from '@/new-services/planning.service'

import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        NewModal,
        NewSelect,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        waveId: {
            type: Number,
            required: true,
        },
        date: {
            type: String,
            required: true,
        },
        sectorIds: {
            type: Array as PropType<number[]>,
            default: () => [],
        },
        cargoType: {
            type: Number,
            default: null,
        },
    },
    emits: ['submit', 'cancel'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            containerIds: [] as number[],
        })

        const containers_state = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as Container[],
        })

        const loadContainers = async () => {
            try {
                containers_state.is_loading = true

                const response = await planningAPI.getContainers({
                    waveId: props.waveId,
                    date: props.date,
                    sectorIds: props.sectorIds,
                    cargoType: props.cargoType,
                    statusIds: [2, 7],
                })

                containers_state.list = response.data.data

                containers_state.is_failed = false
            } catch (error) {
                console.error(error)
                containers_state.is_failed = true
                notifications.notifyError({
                    error,
                    title: 'При получении списка контейнеров произошла ошибка',
                })
            } finally {
                containers_state.is_loading = false
            }
        }

        const onSubmit = () => {
            if (props.loading) return

            const payload: AssemblyContainersPayload = {
                containerIds: state.containerIds,
                waveId: props.waveId,
                date: props.date,
                sectorIds: props.sectorIds,
            }

            emit('submit', payload)
        }

        const onCancel = () => {
            if (props.loading) return
            emit('cancel')
        }

        //

        onBeforeMount(loadContainers)

        //

        return {
            state,
            containers_state,
            loadContainers,
            onSubmit,
            onCancel,
        }
    },
})
